import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  AlertCircle, AlertTriangle, Wrench, ThumbsUp, Clock, CheckCircle,
  ShieldCheck, Star,
} from "lucide-react";

export const PanneUrgentTip = ({ tip }) => (
  <section className="bg-amber-50 border-y-2 border-amber-200">
    <div className="container-custom max-w-5xl py-6">
      <div className="flex items-start gap-4">
        <AlertTriangle className="h-7 w-7 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <h2 className="font-bold text-amber-900 mb-1">À faire IMMÉDIATEMENT</h2>
          <p className="text-amber-900 leading-relaxed">{tip}</p>
        </div>
      </div>
    </div>
  </section>
);

export const PanneDiagnostic = ({ symptoms, causes }) => (
  <section className="section-padding bg-white" data-testid="panne-diagnostic">
    <div className="container-custom max-w-5xl">
      <div className="grid md:grid-cols-2 gap-8">
        <Card className="border-2 border-red-100">
          <CardContent className="p-6 md:p-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <AlertCircle className="h-6 w-6 text-red-600" />
              Symptômes courants
            </h2>
            <ul className="space-y-3">
              {symptoms.map((s) => (
                <li key={s} className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 bg-red-500 rounded-full flex-shrink-0"></span>
                  <span className="text-slate-700 leading-relaxed">{s}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="border-2 border-slate-100">
          <CardContent className="p-6 md:p-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <Wrench className="h-6 w-6 text-slate-700" />
              Causes possibles
            </h2>
            <ul className="space-y-3">
              {causes.map((c) => (
                <li key={c} className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 bg-slate-500 rounded-full flex-shrink-0"></span>
                  <span className="text-slate-700 leading-relaxed">{c}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  </section>
);

export const PanneSolution = ({ solution, durationLabel }) => (
  <section className="section-padding bg-slate-50" data-testid="panne-solution">
    <div className="container-custom max-w-4xl">
      <div className="text-center mb-8">
        <Badge className="bg-green-100 text-green-700 px-4 py-2 mb-4 hover:bg-green-100">
          <ThumbsUp className="w-4 h-4 mr-1" />
          Solution Mediastore
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Notre méthode de réparation
        </h2>
      </div>

      <Card className="bg-white border-slate-200">
        <CardContent className="p-8">
          <p className="text-lg text-slate-700 leading-relaxed">{solution}</p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-slate-100">
            <div className="text-center">
              <Clock className="h-8 w-8 mx-auto text-red-600 mb-2" />
              <p className="font-bold text-slate-900 text-sm">{durationLabel}</p>
              <p className="text-xs text-slate-500">Intervention</p>
            </div>
            <div className="text-center">
              <CheckCircle className="h-8 w-8 mx-auto text-red-600 mb-2" />
              <p className="font-bold text-slate-900 text-sm">Diagnostic gratuit</p>
              <p className="text-xs text-slate-500">Sans engagement</p>
            </div>
            <div className="text-center">
              <ShieldCheck className="h-8 w-8 mx-auto text-red-600 mb-2" />
              <p className="font-bold text-slate-900 text-sm">Garantie 6 mois</p>
              <p className="text-xs text-slate-500">Pièces + main-d&apos;œuvre</p>
            </div>
            <div className="text-center">
              <Star className="h-8 w-8 mx-auto text-red-600 mb-2" />
              <p className="font-bold text-slate-900 text-sm">4,6/5 Google</p>
              <p className="text-xs text-slate-500">212+ avis</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  </section>
);
